import { getAuth, signOut } from 'firebase/auth';
import { firebaseApp, isFirebaseConfigured } from '../firebase/config';

export async function clearAdminSession() {
  if (isFirebaseConfigured() && firebaseApp) {
    try {
      await signOut(getAuth(firebaseApp));
    } catch (e) {
      console.error(e);
    }
  }
  localStorage.removeItem('token');
  localStorage.removeItem('user_data');
  localStorage.removeItem('auth_provider');
}
